import React, { useState, useEffect, useCallback } from "react";
import "./title.css";
import ProgressBar from "../ProgressBar/ProgressBar";
import CandidateSignupButton from "../../pages/PostAJob/EmployerProfile/components/CandidateBackNext/CandidateSignupButton";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchKeySearchDiscipline,
  candidateDetailSuccess,
} from "../../redux/actions";
import { AutoComplete, Spin } from "antd";
import history from "../../routes/history";
import { debounce } from "../../shared/helpers";
import errorIcon from "../../assets/img/ci_warning.png";

const SkillListingTitle = () => {
  const dispatch = useDispatch();

  const getInputValues = useSelector(
    (state) => state.candidateReducer.candidateDetails
  );
  const initialTitle = getInputValues?.title || "";

  const [title, setTitle] = useState(initialTitle);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noDataViewSkills, setNoDataViewSkills] = useState("");
  const [showError, setShowError] = useState(false);
  const [lengthError, setLengthError] = useState(false);

  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const professionCode = userProfile?.Professions?.ProfessionCode;

  const searchedDiscipline = useSelector(
    (state) => state.skillListingReducer.searchedDiscipline
  );

  const disciplineLoader = useSelector(
    (state) => state.skillListingReducer.disciplineLoader
  );

  useEffect(() => {
    if (searchedDiscipline && searchedDiscipline.length > 0) {
      setSuggestions(searchedDiscipline.map((discipline) => discipline.Name));
    } else {
      setSuggestions([]);
    }
  }, [searchedDiscipline]);

  useEffect(() => {
    setTitle(initialTitle);
  }, [initialTitle]);

  const backFunction = () => {
    history.push("/select-gig-type");
  };

  const nextFunction = () => {
    setLoading(true);
    setTimeout(() => {
      if (!title?.length) {
        setLoading(false);
        setShowError(true);
        setLengthError(false);
      } else if (title.length > 100) {
        setLoading(false);
        setLengthError(true);
      } else {
        setLoading(false);
        setShowError(false);
        setLengthError(false);
        dispatch(candidateDetailSuccess({ ...getInputValues, title: title }));
        history.push("/candidate-skill");
      }
    }, 2000);
  };

  const skipFunction = () => {
    history.push("/candidate-skill");
  };

  const handleSkillChange = (value) => {
    setTitle(value);
    setShowError(false);
    setLengthError(false);
  };

  const onSearchSkillsTitle = (value) => {
    setShowError(false);
    setLengthError(false);
    if (value !== "") {
      setNoDataViewSkills(value);
      dispatch(
        fetchKeySearchDiscipline({ val: value, profCode: professionCode })
      );
    }
  };

  const debouncedSearch = useCallback(debounce(onSearchSkillsTitle, 800), [
    dispatch,
  ]);

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar
          heading={"Create candidate’s skill listing"}
          percent={50}
        />
        <div className="email-text">
          Add skill listing title
          <div className="email-mandatory">(Optional)</div>
        </div>

        <div
  style={{
    marginLeft: window.innerWidth < 786 ? "13px" : "",
    marginTop: window.innerWidth < 786 ? "-40px" : ""
  }}
>
          <div className="mobilesub"></div>

          <AutoComplete
            loading={disciplineLoader}
            placeholder="Add title" 
            className="Title-input"
            value={title}
            onSearch={debouncedSearch}
            onChange={handleSkillChange}
            notFoundContent={
              noDataViewSkills?.length > 0 ? (
                <div>
                  {disciplineLoader || suggestions.length > 0 ? (
                    <Spin size="small" />
                  ) : (
                    "No data found!"
                  )}
                </div>
              ) : null
            }
            dropdownStyle={{ width: "310px" }}
          >
            {suggestions.map((suggestion, index) => (
              <AutoComplete.Option key={index} value={suggestion}>
                {searchedDiscipline.length > 0 ? suggestion : ""}
              </AutoComplete.Option>
            ))}
          </AutoComplete>

          {showError && (
            <div className="error-msg-content">
              <img src={errorIcon} alt="" />
              <span className="error-text">Please enter a title to continue</span>
            </div>
          )}

          {lengthError && (
            <div style={{ color: "red" }}>
              Exceeded maximum character length of 100
            </div>
          )}
        </div>

        <div style={{ paddingTop: "25%" }}>
          <CandidateSignupButton
            nextFunction={nextFunction}
            backFunction={backFunction}
            skipFunction={skipFunction}
            nextBtnLoading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default SkillListingTitle;
